module.exports = __webpack_public_path__ + "static/media/air-asia-logo.b93785bf.png";